export default __webpack_public_path__ + "static/media/nft-card-collectio.28441c4f.svg";